import { render, staticRenderFns } from "./documentType.vue?vue&type=template&id=9c5b5a34&scoped=true&"
import script from "./documentType.vue?vue&type=script&lang=js&"
export * from "./documentType.vue?vue&type=script&lang=js&"
import style0 from "./documentType.vue?vue&type=style&index=0&id=9c5b5a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5b5a34",
  null
  
)

export default component.exports